import settings from "../utils/settings";
import SFError from "../models/SfError";
const useBatchUpdateBadgeSetting = () => {
  const updateBadges = async (datas) => {
    const { token } = settings();

    const results = await Promise.all(
      datas.map(async (data) => {
        try {
          const result = await fetch(
            `${process.env.REACT_APP_API_ENDPOINT}/member-badges/${data.id}`,
            {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
              body: JSON.stringify({
                conditions: [
                  {
                    value: data.conditionValue,
                    condition_id: data.conditionId,
                  },
                ],
                __v: data.__v,
              }),
            }
          );
          if (!result.ok) {
            const jsonResult = await result.json();
            const error = new SFError({
              status: result.status,
              code: jsonResult.code,
              message: jsonResult.message,
            });

            return error.json();
          }
          const jsonResult = await result.json();

          return jsonResult;
        } catch (error) {
          return "Error";
        }
      })
    );

    const isErrorFound = results.some((result) => {
      return result.error;
    });
    if (isErrorFound) {
      return { error: true, message: "Something went wrong" };
    }
    return { message: "Update success" };
  };

  return { updateBadges };
};

export default useBatchUpdateBadgeSetting;
